.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 240px;
  margin-top: 16px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.backgroundImage {
  border-radius: 20px;
  object-fit: cover;
  position: absolute;
  z-index: -1;
}

.cta {
  border: none;
  border-radius: var(--border-radius-sm);
  padding: 16px 32px;
  margin-top: 8px;
}
